const Sponsors = ({ items }) => (
  <div className="bg-sec-grey-4 pt-16 lg:pt-24 pb-16 lg:pb-24 px-2 lg:px-18">
    <div className="grid grid-cols-1 place-items-center">
      {items &&
        items.map((sponsorGroup, idx) => (
          <div key={idx}>
            <div className="pt-6 pb-4 lg:pt-20 lg:pb-8">
              <p className="text-black text-center opacity-50 text-[12px] font-alliance-medium lg:text-[20px]">
                {sponsorGroup?.titulo}
              </p>
            </div>
            <div className="flex flex-wrap justify-center">
              {sponsorGroup?.patrocinadores.map((sponsor, sidx) => {
                const { url, alternativeText } = sponsor.logo.data.attributes
                return (
                  <a
                    key={sidx}
                    href={sponsor.website}
                    target="_blank"
                    rel="noreferrer"
                    className="mx-3 my-2 lg:mx-8 lg:my-4"
                  >
                    <img src={url} alt={alternativeText} />
                  </a>
                )
              })}
            </div>
          </div>
        ))}
    </div>
  </div>
)

export default Sponsors
